import React from 'react';
import classnames from 'classnames';
import { Button } from 'react-bootstrap';
import SubmitButtonTooltip from '../../CheckResponse/SubmitButtonTooltip';
import styles from './proposalRespondModal.module.scss';

interface FooterButtonsProps {
  onCancel: () => void;
  isSubmitDisabled: boolean;
  showSubmitTooltip: boolean;
  isDetailsFormat?: boolean;
}

const FooterButtons = ({
  onCancel,
  isSubmitDisabled,
  showSubmitTooltip,
  isDetailsFormat = false,
}: FooterButtonsProps) => {
  const showTooltip = showSubmitTooltip
    ? 'You must check your response first before you can proceed to the next step.'
    : undefined;

  return (
    <>
      <Button
        variant="secondary"
        className={classnames('btn-secondary-dark', styles.cancelBtn, {
          [styles.isDetailsFormat]: isDetailsFormat,
        })}
        onClick={onCancel}
      >
        Cancel
      </Button>
      <SubmitButtonTooltip
        disabled={isSubmitDisabled}
        toolTipMessage={showTooltip}
        isDetailsFormat={isDetailsFormat}
      />
    </>
  );
};

export default FooterButtons;
